'use client';

import { useEffect, useRef } from 'react';
import { usePageHistory } from '../pageWrappers/usePageHistory';
import { usePathname } from 'next/navigation';
import { WebApi404Data } from '../dataCollector/types/dataCollector.types';
import { WebAPIMetadata } from '../webApiTypes/elements/WebAPIMetadata';
import { WebAPIBase } from '../webApiTypes/base/WebAPIPage';
import { AllProviderTypes } from '../config/providerTypes';

export const UpdatePageHistory = ({
	status,
	opPartner,
	providerType,
	url,
}: {
	status: WebAPIBase['status'] | WebApi404Data['status'];
	opPartner: WebAPIMetadata['op:partner'] | undefined;
	providerType: AllProviderTypes;
	url: WebAPIBase['url'];
}) => {
	const pathnameRef = useRef<unknown | undefined>(undefined);
	const [, dispatchPageHistory] = usePageHistory();
	const pathname = usePathname();

	useEffect(() => {
		// Only fire dispatch if the pathname has changed
		if (pathnameRef.current === pathname) {
			return;
		}
		pathnameRef.current = pathname;
		if (status === '404') {
			dispatchPageHistory({
				partners: undefined,
				providerType: undefined,
				pathname,
			});
		} else {
			dispatchPageHistory({
				partners: opPartner,
				providerType: providerType,
				pathname: url,
			});
		}
	}, [dispatchPageHistory, opPartner, pathname, providerType, status, url]);
	return null;
};
